export default {
    black: '#222222',

    error: '#FF5252',
    info: '#38afff',
    light: '#ffffff',
    neutral: '#34313F',

    primary: '#611F96',
    secondary: '#C35BE3',
    success: '#4CAF50',
    warning: '#ffc830',
}
